export const ITEM_OWNERSHIP = {
    owner: {
        id: 'owner',
        name: 'item.ownership.owner.text',
        capabilities: [6, 1, 2, 3, 4, 5, 7, 8],
    },
    editor: {
        id: 'editor',
        name: 'item.ownership.editor.text',
        capabilities: [6, 1, 2],
    },
    readonly: {
        id: 'readonly',
        name: 'item.ownership.readonly.text',
        capabilities: [6],
    },
};
export const ITEM_OWNERSHIP_CAPABILITIES = {
    1: {
        category: 1,
        desc: 'item.ownership.capability.1',
    },
    2: {
        category: 2,
        desc: 'item.ownership.capability.2',
    },
    3: {
        category: 1,
        desc: 'item.ownership.capability.3',
    },
    4: {
        category: 1,
        desc: 'item.ownership.capability.4',
    },
    5: {
        category: 1,
        desc: 'item.ownership.capability.5',
    },
    6: {
        category: 1,
        desc: 'item.ownership.capability.6',
    },
    7: {
        category: 1,
        desc: 'item.ownership.capability.7',
    },
    8: {
        category: 1,
        desc: 'item.ownership.capability.8',
    },
};
export const ITEM_OWNERSHIP_CAPABILITY_CATEGORIES = {
    1: {
        name: 'item.ownership.capability.category.1',
    },
    2: {
        name: 'item.ownership.capability.category.2',
    },
};
export const ITEM_OWNERSHIP_OPTIONS = Object.keys(ITEM_OWNERSHIP).map((ownershipId) => ({
    label: ITEM_OWNERSHIP[ownershipId].name,
    value: ITEM_OWNERSHIP[ownershipId]
        .id,
}));
export const ITEM_OWNERSHIP_CAPABILITY_LOOKUP = Object.keys(ITEM_OWNERSHIP).reduce((all, current) => {
    const capabilityDescs = ITEM_OWNERSHIP[current].capabilities.map((capabilityId) => ITEM_OWNERSHIP_CAPABILITIES[capabilityId].desc);
    return {
        ...all,
        [current]: capabilityDescs,
    };
}, {});
export const DEFAULT_ITEM_OWNERSHIP = ITEM_OWNERSHIP.readonly
    .id;
//# sourceMappingURL=item-ownership.js.map